import React, { FC } from 'react'

import { styled } from '@linaria/react'
import { FormattedMessage } from 'react-intl'

import { RouterLink } from 'components/designSystem/Link/RouterLink'
import { MaskLastPhotoSvg } from 'components/designSystem/svgr/MaskLastPhotoSvg'
import { Typography } from 'components/designSystem/Typography/Typography'

import { usePhotoUrl } from './hooks/usePhotoUrl'

export const ProfilePhotoMore: FC<{
  photoId: number
  source: string
  count: number
}> = ({ photoId, source, count }) => {
  const photoUrl = usePhotoUrl(photoId)

  return (
    <Parent to={photoUrl} data-name={`photoviewer-${photoId}-more`}>
      <ParentMask>
        <MaskImage />
        <Image src={source} alt="" title="" />
        <Filter />
        <Text
          fontSize={20}
          fontWeight={500}
          tag="p"
          data-name={`photoviewer-mask-${photoId}-more`}
        >
          <FormattedMessage
            defaultMessage="еще {breakLine} {count} фото"
            id="app.foreign.profile.more.photos"
            values={{
              count,
              breakLine: <br />,
            }}
          />
        </Text>
      </ParentMask>
    </Parent>
  )
}

const Parent = styled(RouterLink)`
  position: relative;
  display: flex;
  justify-content: center;
`

const ParentMask = styled.div`
  width: 262px;
  height: 268px;
  position: relative;
`

const MaskImage = styled(MaskLastPhotoSvg)`
  position: absolute;
  top: 0;
  z-index: 1;
`

const Image = styled.img`
  object-fit: cover;
  width: 210px;
  height: 210px;
  position: absolute;
  top: 34px;

  html[dir='ltr'] & {
    left: 28px;
  }

  html[dir='rtl'] & {
    right: 28px;
  }

  z-index: 1;
  clip-path: path(
    'M11.122 144.533c27.406 73.661 125.742 58.967 154.159 40.283C237.603 133.024 222.377 8.337 125.314.664 28.251-7.009-23.136 52.457 11.122 144.533Z'
  );
`

const Filter = styled.div`
  position: absolute;
  left: 28px;
  top: 34px;
  width: 210px;
  height: 210px;
  opacity: 0.8;
  background-color: var(--purpur-hard);
  clip-path: path(
    'M11.122 144.533c27.406 73.661 125.742 58.967 154.159 40.283C237.603 133.024 222.377 8.337 125.314.664 28.251-7.009-23.136 52.457 11.122 144.533Z'
  );
  z-index: 1;
`

const Text = styled(Typography)`
  position: absolute;
  width: 74px;
  height: 48px;
  top: 110px;
  text-align: center;

  html[dir='ltr'] & {
    left: 96px;
  }

  html[dir='rtl'] & {
    right: 96px;
  }

  color: var(--static-white);
  z-index: 1;
`
